import React, { useState, useEffect } from "react";
import usePermissions from "../../Hooks/hook-permissions";
import { getUser as getAuthUser } from "../../../utils/globals/authUser";
import OnBoard from "../../Sub/OnBoard/OnBoard";
import Profile from "../../Sub/Profile/Profile";
import VideoChat from "../../Sub/VideoChat/VideoChat";

const Home = () => {
  const [user, setUser] = useState();

  const {
    hasCameraPermission,
    hasAudioPermission,
    isCameraPermissionBlocked,
    isAudioPermissionBlocked,
  } = usePermissions();

  const handleProfileChange = (newUserProfile) => {
    setUser({ ...newUserProfile });
  };

  useEffect(() => {
    // get user from auth
    const _user = getAuthUser() || {};

    // update user state
    setUser({ ..._user });
  }, []);

  return (
    <div className="my-4 w-full flex flex-col screenVC:flex-row">
      {(!hasCameraPermission || !hasAudioPermission) && (
        <OnBoard
          showGrantButton={
            !isCameraPermissionBlocked && !isAudioPermissionBlocked
          }
        />
      )}
      {(!user?.name || !user?.avatarFormula) &&
        hasCameraPermission &&
        hasAudioPermission && (
          <div className="w-full px-3 sm:px-24 flex justify-center">
            <Profile
              user={user}
              editMode={true}
              onProfileChange={handleProfileChange}
              showCancelEditButton={false}
            />
          </div>
        )}
      {user?.name &&
        user?.avatarFormula &&
        hasCameraPermission &&
        hasAudioPermission && <VideoChat />}
    </div>
  );
};

export default Home;
